import TagManager from 'react-gtm-module';

const gtmId = process.env.REACT_APP_GTM_ID;
const isDevelopment = process.env.NODE_ENV === 'development';

export const initGtm = () => {
  if (!gtmId) {
    return;
  }

  if (!isDevelopment) {
    TagManager.initialize({
      gtmId: gtmId,
    });
  }
};

export const setDataLayer = (value) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push(value);
};
